import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';
import GS from '../../grafsync/grafsync';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../withGShoc';

class ResourceLorem extends React.Component {

    render() {

        const { data, lang, property, labelProp } = this.props;
        const alias = GS.getAlias(property) || property;

        return (
            <Typography variant="body2" style={{ fontSize: 12 }}>
                <span style={{ display: 'inline-block', width: 205, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {
                        alias === "type" ?
                            Array.isArray(data[alias]) ?
                                data[alias].filter(classType => data[alias].length === 1 || classType !== "Concept")[0]
                                :
                                data[alias]
                            :
                            property === "https://grafsync.graphifi.com/schema/tsv/hierarchy"
                                || property === "https://grafsync.graphifi.com/schema/tsv/concepts" ?
                                data[labelProp] && data[labelProp][lang] ?
                                    Array.isArray(data[labelProp][lang]) ?
                                        data[labelProp][lang].sort().join(",")
                                        :
                                        data[labelProp][lang]
                                    :
                                    "No value available"
                                :
                                property === "https://grafsync.graphifi.com/schema/tsv/IRI" ?
                                    <Tooltip title={data.id}>
                                        <span>{data.id}</span>
                                    </Tooltip>
                                    :
                                    alias in data ?
                                        Array.isArray(data[alias]) ?
                                            data[alias][0]["language"] ?
                                                data[alias].some(item => item.language === lang) ?
                                                    data[alias].find(item => item.language === lang)["@value"]
                                                    :
                                                    null
                                                :
                                                data[alias][0]["@value"] ?
                                                    data[alias][0]["@value"]
                                                    :
                                                    data[alias][0].id ?
                                                        <Tooltip title={data[alias][0].id}>
                                                            <span>{data[alias][0].id}</span>
                                                        </Tooltip>
                                                        :
                                                        data[alias][0]
                                            :
                                            typeof data[alias] === "boolean" ?
                                                data[alias] === true ?
                                                    "TRUE"
                                                    :
                                                    "FALSE"
                                                :
                                                data[alias]["@value"] ?
                                                    data[alias]["@value"]
                                                    :
                                                    lang ?
                                                        data[alias][lang] ?
                                                            Array.isArray(data[alias][lang]) ?
                                                                data[alias][lang][0]
                                                                :
                                                                data[alias][lang]
                                                            :
                                                            typeof data[alias] === "string" ?
                                                                data[alias]
                                                                :
                                                                null
                                                        :
                                                        typeof data[alias] === "string" ?
                                                            data[alias]
                                                            :
                                                            null
                                        :
                                        null
                    }
                </span>
            </Typography>
        );
    }
}

ResourceLorem.propTypes = {
    labelProp: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    property: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired
};

export default withGS(ResourceLorem, ["ALL"], null, {}, true);